import React from 'react'

export default class PerfilSocial extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="mt-5 font-weight-bold text-left">
                    1 - DADOS DO PERFIL SOCIAL:
                </div>
                <div className="form-group row mt-3">
                    <label className="col-3 col-md-2">Pefil Social:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            name="perfilSocial"
                            {...this.props}
                            value={this.props.value.perfilSocial} />
                    </div>
                    <label className="col-3 col-md-2">Rede Social:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="redeSocial"
                            {...this.props}
                            value={this.props.value.redeSocial} >
                            <option value=""></option>
                            <option value="Facebook">Facebook</option>
                            <option value="Instagram">Instagram</option>
                            <option value="Facebook e Instagram">Facebook e Instagram</option>
                            <option value="Outros">Outros</option>
                        </select>
                    </div>
                    <label className="col-3 col-md-2">Tipo de Perfil:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="tipoPerfil"
                            {...this.props}
                            value={this.props.value.tipoPerfil} >
                            <option value=""></option>
                            <option value="Privado">Privado</option>
                            <option value="Público">Público</option>
                        </select>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}